import { motion } from "framer-motion";
import { Car, Flame, Snowflake, Train, Tv } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

const EASE = [0.22, 1, 0.36, 1];
const ICONS = [Snowflake, Flame, Tv, Car, Train];

export default function ComfortBand() {
  const { t } = useLanguage();

  return (
    <section id="comfort" data-testid="comfort-section" className="relative bg-cypress text-linen py-20 lg:py-28 overflow-hidden">
      <span
        aria-hidden="true"
        className="absolute -bottom-10 left-0 font-serif italic text-[22vw] leading-none text-linen/[0.04] select-none whitespace-nowrap pointer-events-none"
      >
        casa paola
      </span>

      <div className="relative px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-sand/70 font-bold mb-4"
        >
          {t.comfort.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
          className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight max-w-3xl text-balance"
        >
          {t.comfort.titleA}{" "}
          <em className="text-terracotta">{t.comfort.titleB}</em>
        </motion.h2>

        <div className="mt-12 flex flex-wrap gap-3 sm:gap-4">
          {t.comfort.chips.map((label, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={label}
                data-testid={`comfort-chip-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: 0.15 + i * 0.08, ease: EASE }}
                whileHover={{ y: -4, backgroundColor: "rgba(251,248,245,0.14)" }}
                className="flex items-center gap-3 rounded-full border border-linen/20 bg-linen/[0.07] backdrop-blur px-5 py-3"
              >
                <Icon className="w-4 h-4 text-sand" />
                <span className="text-sm sm:text-base font-medium">{label}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
